import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../Auth.css';
import logo from '../../../assets/images/seedxpert-light.png';
import { useTranslation } from 'react-i18next';

const ForgotPassword = () => {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');
    setError('');

    try {
      const response = await axios.post('/api/auth/forgot-password', { 
        email,
        language: i18n.language 
      });
      
      setMessage(t('forgotPassword.successMessage'));
    } catch (err) {
      setError(t('forgotPassword.errorMessage'));
    }
    setIsLoading(false);
  };

  return (
    <div className="auth-container">
      {/* Animasyonlar */}
      <div className="bg-animation">
        <div className="floating-shape shape-1"></div>
        <div className="floating-shape shape-2"></div>
        <div className="floating-shape shape-3"></div>
      </div>

      {/* DÜZELTME: Stillerin yüklenmesi için register-box kullanıldı */}
      <div className="register-box" style={{ maxWidth: '450px', margin: '0 auto' }}> 
        <div className="logo-section">
          <img src={logo} alt="SeedXpert Logo" className="auth-logo" />
        </div>

        <div className="auth-header">
          <h2>{t('forgotPassword.title')}</h2>
          <p className="auth-subtitle">{t('forgotPassword.subtitle')}</p>
        </div>

        {message && <div className="success-message">{message}</div>}
        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{t('forgotPassword.emailLabel')}</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('forgotPassword.emailPlaceholder')}
              required
            />
          </div>
          <br/>
          <button type="submit" className="auth-btn primary-btn" disabled={isLoading}>
            {isLoading ? (t('common.processing') || '...') : t('forgotPassword.submitButton')}
          </button>

          <div className="auth-footer">
            <span className="back-link" onClick={() => navigate('/')} style={{cursor: 'pointer', color: '#667eea'}}>
              ← {t('forgotPassword.backToLogin')}
            </span>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;